import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * Visible FAQ accordion. Renders semantic <details>/<summary> so Google can
 * still read the content even before JS hydrates — and so screen readers get
 * native expand/collapse behaviour. Paired with FAQPage JSON-LD from
 * `src/lib/faqs.js` for rich SERP results.
 */
const FaqSection = ({ title = 'Frequently asked questions', faqs = [], testIdPrefix = 'faq' }) => {
  const [open, setOpen] = useState(null);
  if (!faqs.length) return null;

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white dark:bg-neutral-950" data-testid={`${testIdPrefix}-section`}>
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-black text-gray-900 dark:text-neutral-100 mb-8 text-center">
          {title}
        </h2>
        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                data-testid={`${testIdPrefix}-item-${i}`}
                className="border border-gray-200 dark:border-neutral-800 rounded-2xl overflow-hidden bg-white dark:bg-neutral-900"
              >
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full px-5 py-4 flex items-center justify-between text-left hover:bg-gray-50 dark:hover:bg-neutral-800/50 transition-colors"
                  aria-expanded={isOpen}
                >
                  <span className="font-bold text-gray-900 dark:text-neutral-100 pr-4">
                    {f.question}
                  </span>
                  <ChevronDown
                    size={20}
                    className={`shrink-0 text-gray-500 dark:text-neutral-400 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                  />
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 text-base text-gray-700 dark:text-neutral-300 leading-relaxed">
                    {f.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
